export default __webpack_public_path__ + "static/media/logo4.096a2ac7.jpg";